(function(){
 function initialize(root){
   const walls=[];
   if(root.matches?.('novari-review-wall'))walls.push(root);
   if(root.querySelectorAll)walls.push(...root.querySelectorAll('novari-review-wall'));
   walls.forEach(wall=>{
     if(wall.dataset.wallReady==='true')return;
     wall.dataset.wallReady='true';
     const grid=wall.querySelector('.nc-review-wall__grid');
     const load=wall.querySelector('[data-load-more]');
     if(!grid)return;
     const originals=[...grid.querySelectorAll('.nc-review-wall__card')];
     const photos=originals.filter(card=>card.dataset.photo==='yes');
     const texts=originals.filter(card=>card.dataset.photo!=='yes');
     const mixed=[];
     while(photos.length||texts.length){
       if(photos.length)mixed.push(photos.shift());
       if(texts.length)mixed.push(texts.shift());
     }
     mixed.forEach(card=>grid.appendChild(card));
     const step=Math.max(1,parseInt(wall.dataset.step,10)||8);
     const initial=Math.max(1,parseInt(wall.dataset.initial,10)||step);
     const singleLoad=wall.dataset.singleLoad==='true';
     let clickedOnce=false;
     let shown=Math.min(initial,mixed.length);
     function refresh(){
       mixed.forEach((card,i)=>{
         card.hidden=i>=shown;
         card.setAttribute('aria-hidden',i>=shown?'true':'false');
       });
       if(load){load.hidden=shown>=mixed.length||(singleLoad&&clickedOnce);load.setAttribute('aria-expanded',(shown>=mixed.length||(singleLoad&&clickedOnce))?'true':'false');}
     }
     if(load)load.addEventListener('click',()=>{
       if(singleLoad&&clickedOnce)return;
       const firstNew=mixed[shown];
       shown=Math.min(shown+step,mixed.length);
       if(singleLoad)clickedOnce=true;
       refresh();
       if(firstNew && window.matchMedia('(prefers-reduced-motion: reduce)').matches===false){
         // Keep the scroll position steady; newly added cards remain in the existing masonry grid.
       }
     });
     refresh();
   });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(document));
 else initialize(document);
 document.addEventListener('shopify:section:load',e=>initialize(e.target));
})();